import {
  useRecordContext,
  RecordContextProvider,
  NumberField,
  useTranslate,
  TextField,
} from "react-admin";
import Box from "@mui/material/Box";

const RestockPlanExpandList = () => {
  const record = useRecordContext();
  const t = useTranslate();

  return (
    <Box
      sx={{
        m: 5,
        backgroundClip: "padding-box",
        boxShadow: (theme) => {
          return theme.components.MuiPaper
            ? theme.components.MuiPaper.styleOverrides.elevation1.boxShadow
            : undefined;
        },
        borderRadius: "4px",
        bgcolor: "background.paper",
      }}
    >
      <Box
        component="table"
        sx={{
          width: "100%",
          // bgcolor: "rgba(0,0,0,.04)",
          // fontSize: "smaller",
          borderCollapse: "collapse",
          "& th, td": {
            padding: "6px 8px",
            border: "1px solid #dddddd",
          },
        }}
      >
        <thead>
          <tr>
            <th style={{ textAlign: "center", width: "3.09%" }}>No.</th>
            <th style={{ width: "10.09%" }}>{t("mine.label.code")}</th>
            <th style={{ textAlign: "right", width: "6.381%" }}>
              Avg Sales / Bln
            </th>
            <th style={{ textAlign: "right", width: "6.381%" }}>
              {t("mine.label.effective_month")}
            </th>
            <th style={{ textAlign: "right", width: "6.381%" }}>
              {t("mine.label.day_range")}
            </th>
            <th style={{ textAlign: "right", width: "6.381%" }}>
              Buffer Minimal
            </th>
            <th style={{ textAlign: "right", width: "6.381%" }}>
              Buffer Maximal
            </th>
            <th style={{ textAlign: "right", width: "6.381%" }}>
              {t("mine.label.stock")}
            </th>
            <th style={{ textAlign: "right", width: "6.381%" }}>R Minimal</th>
            <th style={{ textAlign: "right", width: "6.381%" }}>R Maximal</th>
            <th style={{ textAlign: "right", width: "6.381%" }}>BDP</th>
            <th style={{ textAlign: "right", width: "6.381%" }}>
              {t("mine.label.final")}
            </th>
            <th style={{ width: "23%" }}>{t("mine.label.note")}</th>
          </tr>
        </thead>
        <tbody>
          {record.restock_plan_items.map((item, idx) => {
            return (
              <tr key={item.id + idx}>
                <td style={{ textAlign: "center" }}>{idx + 1}</td>
                <td>
                  <RecordContextProvider value={item}>
                    <TextField
                      source="ten_code"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="average_sales"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="effective_months"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="day_range"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="buffer_minimal"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="buffer_maximal"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="stock"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="restock_minimal"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="restock_maximal"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="goods_in_transit"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textAlign: "right" }}>
                  <RecordContextProvider value={item}>
                    <NumberField
                      source="final"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
                <td style={{ textTransform: "uppercase" }}>
                  <RecordContextProvider value={item}>
                    <TextField
                      source="note"
                      emptyText="-"
                      sx={{
                        fontSize: "inherit",
                      }}
                    />
                  </RecordContextProvider>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Box>
    </Box>
  );
};

export default RestockPlanExpandList;
